<template>
  <div class="metric-rating-grid">
    <table :class="['grid-wide',hiddenClass]">
      <tr v-if="hasColumnHeadings">
        <td class="label"></td>
        <template v-for="c in numColumns">
          <th v-if="headingForColNum(c)" :key="c" class="value">{{headingForColNum(c)}}</th>
          <td v-else :key="c" class="value"></td>
        </template>
      </tr>
      <tr v-for="n in numRows" :key="n">
        <td class="label">{{labelForRowNum(n)}}</td>
        <td class="value"
          v-for="c in numColumns"
          :key="c"
          >
          <VizFourBarRating class="small" :rating="ratingForCell(n,c)"/>
        </td>
      </tr>
    </table>
    <div :class="['grid-tall',hiddenClass]">
      <div v-for="c in numColumns" :key="c" class="col-group">
        <div v-if="hasColumnHeadings" class="heading">{{headingForColNum(c)}}</div>
        <div v-for="n in numRows" :key="n" class="row-group">
          <div class="label">{{labelForRowNum(n)}}</div>
          <div class="value">
            <VizFourBarRating class="small" :rating="ratingForCell(n,c)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component'

import MetadataBase from './MetadataBase'
import VizFourBarRating from '@/components/VizFourBarRating'

/* Prefix (followed by <row>_<col> numbers) for Valid Slot Names for this Component */
const SN_RATING_PREFIX = 'rating_value_'
const SN_COL_PREFIX = 'col_heading_'

@Component({
  components: {
    VizFourBarRating
  }
})
export default class MetricRatingGrid extends MetadataBase {
  /* Getters */

  get ratingSlotData () {
    return this.slotDataForPrefix(SN_RATING_PREFIX)
  }
  get numRows () {
    const indexes = this.ratingSlotData.map(d => this.getRowIndexFromSlot(d))
    return Math.max(...indexes)
  }
  get numColumns () {
    const indexes = this.ratingSlotData.map(d => this.getColIndexFromSlot(d))
    return Math.max(...indexes)
  }

  get colHeadingSlotData () {
    return this.slotDataForPrefix(SN_COL_PREFIX)
  }
  get hasColumnHeadings () {
    return this.colHeadingSlotData.length > 0
  }

  /* Methods - utility */

  getIndexFromRatingSlot (d, i) {
    // i = 1 for row index, 2 for col index
    if (i !== 1 && i !== 2) return undefined
    return +d.component_slot.split('_').slice(-2)[i - 1]
  }
  getRowIndexFromSlot (d) {
    return this.getIndexFromRatingSlot(d, 1)
  }
  getColIndexFromSlot (d) {
    return this.getIndexFromRatingSlot(d, 2)
  }

  headingForColNum (n) {
    return this.displayTextForSlotName(`${SN_COL_PREFIX}${n}`)
  }
  labelForRowNum (n) {
    // Assume the display text is attached to the first column's slot
    return this.displayTextForSlotName(`${SN_RATING_PREFIX}${n}_1`)
  }
  ratingForCell (r, c) {
    return this.valueForSlotName(`${SN_RATING_PREFIX}${r}_${c}`)
  }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../css/const.scss';
.metric-rating-grid {
  padding-top: 4px;
  padding-bottom: 24px;
}

.grid-wide {
  tr {
    .label {
      width: 260px;
      text-align: right;
      padding-right: 9px;
    }
    .value {
      width: 70px;
      text-align: center;
    }
  }
  th {
    font-weight: normal;
  }
}

.grid-tall {
  padding-top: 12px;
  line-height: 1.2em;
  .col-group {
    padding-bottom: 8px;
  }
  .heading {
    padding-bottom: 8px;
  }
  .row-group {
    padding-bottom: 8px;
    padding-left: 14px;
  }
}

/* Responsive rules */

.grid-wide {
  display: block;
}

@media screen and (max-width: $screen-width-2-column-small) {
.metric-rating-grid {
  padding: 0px;
}
.grid-wide.no-calc-hidden {
  display: none;
}
.grid-tall {
  display: block;
}
}
@media screen and (max-width: $screen-width-1-column-large)
  and (min-width: $screen-width-1-column-small) {
.metric-rating-grid {
  padding-top: 4px;
  padding-bottom: 24px;
}
.grid-wide.no-calc-hidden {
  display: block;
}
.grid-tall.no-calc-hidden {
  display: none;
}
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2018/tab-mods/MetricRatingGrid.vue